import { Code2, ShieldCheck, Terminal } from "lucide-react";

const stats = [
  { value: "2023", label: "QA Automation Focus" },
  { value: "6", label: "Featured Projects" },
  { value: "16", label: "Core Tools & Technologies" },
  { value: "GH", label: "Based in Ghana" },
];

export default function About() {
  return (
    <section id="about" className="px-4 py-16 sm:px-6 sm:py-20 lg:py-28" style={{ background: "var(--background)" }}>
      <div className="mx-auto max-w-6xl">
        <div className="mb-8 sm:mb-12 section-label">// 01 &nbsp; ABOUT</div>
        <div className="grid items-start gap-10 md:grid-cols-2 lg:gap-16">
          <div>
            <h2 className="mb-6 section-heading">
              I build products.<br />Then I test them<br />
              <span style={{ color: "var(--primary)" }}>carefully.</span>
            </h2>
            <p className="mb-5 body-copy">Based in Ghana, I work at the intersection of software development and quality engineering. I build Selenium and Java automation suites, wire them into Jenkins, and collaborate closely with developers to catch issues early.</p>
            <p className="body-copy">The same curiosity that drives my testing work also pushes me to craft practical web and mobile products. I care about maintainable engineering, polished user experience, and feedback loops that keep teams moving.</p>

            <div className="mt-10 grid gap-3 sm:grid-cols-2">
              {[
                { icon: Code2, label: "Developer", detail: "React · Angular · TypeScript · Firebase" },
                { icon: ShieldCheck, label: "QA Engineer", detail: "Selenium · Java · Jenkins · Playwright" },
              ].map(({ icon: Icon, label, detail }) => (
                <div key={label} className="rounded border p-4 card-surface">
                  <Icon size={16} style={{ color: "var(--primary)", marginBottom: "0.5rem" }} />
                  <div className="card-title">{label}</div>
                  <div className="mono-small">{detail}</div>
                </div>
              ))}
            </div>
          </div>

          <div className="flex flex-col gap-6">
            <div className="grid gap-3 sm:grid-cols-2">
              {stats.map(({ value, label }) => (
                <div key={label} className="rounded border p-5 card-surface">
                  <div style={{ fontFamily: "var(--font-display)", fontSize: "clamp(1.75rem, 11vw, 2.25rem)", fontWeight: 600, color: "var(--primary)", lineHeight: 1, marginBottom: "0.375rem" }}>{value}</div>
                  <div className="body-small">{label}</div>
                </div>
              ))}
            </div>

            <div className="overflow-hidden rounded border card-surface">
              <div className="flex items-center gap-2 border-b px-4 py-3" style={{ borderColor: "var(--border)" }}>
                <Terminal size={12} style={{ color: "var(--muted-foreground)" }} />
                <span className="mono-small">ibrahim@portfolio ~ $</span>
              </div>
              <pre className="whitespace-pre-wrap break-words px-4 py-5" style={{ fontFamily: "var(--font-mono)", fontSize: "0.75rem", lineHeight: 1.8, color: "var(--foreground)" }}>
                <span style={{ color: "var(--muted-foreground)" }}>$ </span><span style={{ color: "var(--accent)" }}>whoami</span>{"\n"}
                <span style={{ color: "var(--primary)" }}>{">"} Ibrahim Mustapha · QA automation engineer + software developer{"\n"}</span>
                <span style={{ color: "var(--muted-foreground)" }}>$ </span><span style={{ color: "var(--accent)" }}>cat philosophy.txt</span>{"\n"}
                <span>{">"} Quality is not a phase.{"\n"}</span>
                <span>{">"} It is a practice.{"\n"}</span>
                <span style={{ color: "var(--muted-foreground)" }}>$ _</span>
              </pre>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
